// Constant from history library used by React Router, but is not exported
// https://github.com/ReactTraining/history/blob/5f367d8cbdaf91d7f64e2efdbb9196feb0859f3f/modules/createHashHistory.js#L125
const POP = 'POP';
const PUSH = 'PUSH';
export { POP, PUSH };
